import { RequirablePropertyInputMultipleDomain } from '../../input/PropertyInputGetters';
import { COMPANY_ADDITIONAL_DOMAINS } from '../constants/AdditionalPropertyNames';
import { useAdditionalPropertyValues } from '../hooks/useAdditionalPropertyValues';
import { jsx as _jsx } from "react/jsx-runtime";
const PropertyInputMultipleDomainShim = props => {
  const {
    data: additionalValues,
    loading: additionalValuesLoading
  } = useAdditionalPropertyValues({
    additionalDomains: COMPANY_ADDITIONAL_DOMAINS
  });
  if (additionalValuesLoading || additionalValues === undefined) {
    return null;
  }
  return /*#__PURE__*/_jsx(RequirablePropertyInputMultipleDomain, Object.assign({}, props, {
    additionalDomains: additionalValues.additionalDomains
  }));
};
export default PropertyInputMultipleDomainShim;